// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"d6d928f5","162":"e620701a","223":"9ee78ceb","710":"7768e93d"}[chunkId] + ".chunk.css";
};